const styles = {
  messageError: {
    color: 'rgb(159, 58, 56)',
    marginTop: '-1em',
    marginBottom: '1em',
  },
};
export default styles;
